import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

export default async function slotsByTierAndDate(eventPk, tierPk, dateStr) {
  const pk = eventPk?.pk != null ? eventPk.pk : eventPk;
  const { data } = await axios.get(
    routes.ticketTierSlotsByDate(pk, tierPk, dateStr),
    AXIOS_DEFAULT_CONFIG
  );
  if (Array.isArray(data)) return data;
  return data?.results ?? [];
}
